/* Publish by EComposer at 2026-09-30 16:29:56*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-6y85s9vfjjp"]=  window.__ectimmers["ecom-6y85s9vfjjp"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-6y85s9vfjjp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6y85s9vfjjp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jw8yn7gvz6o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jw8yn7gvz6o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-htxn7v3r6p4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-htxn7v3r6p4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sxgs62ivq98').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sxgs62ivq98', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwl87rnep9p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwl87rnep9p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwnz14zubj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwnz14zubj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o6vcpk3cuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o6vcpk3cuw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7qk42zplpfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7qk42zplpfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-of6b7b1wkle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-of6b7b1wkle', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pr1zzpj5yo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pr1zzpj5yo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x8ceec987dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x8ceec987dg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fh9nhcrik1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fh9nhcrik1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vqilpxlb1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vqilpxlb1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-113diuyvqry').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-113diuyvqry', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i974am33z2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i974am33z2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bz9yz2n5e2o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bz9yz2n5e2o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-25ffn0zqbct').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-25ffn0zqbct', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-431kya17isi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-431kya17isi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmcva068wh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmcva068wh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q924rido2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q924rido2f', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-m362aaegm8m"]=  window.__ectimmers["ecom-m362aaegm8m"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-m362aaegm8m"]["odqwihkgo"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-m362aaegm8m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m362aaegm8m', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yohdj7f4b1l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yohdj7f4b1l', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mo9o93j30of').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mo9o93j30of', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jeemelrgid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jeemelrgid', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hsleuaas6mf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hsleuaas6mf', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1f4resut03p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1f4resut03p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-tt17vqd5nqb"]=  window.__ectimmers["ecom-tt17vqd5nqb"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-tt17vqd5nqb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tt17vqd5nqb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4wxztui5ds9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4wxztui5ds9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d7nfstognhl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d7nfstognhl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zd946ojxpf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zd946ojxpf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}